export const os = (function () {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isMobile: !isPc
  }
})()

var getPixelRatio = function (context) {
  var backingStore =
    context.backingStorePixelRatio ||
    context.webkitBackingStorePixelRatio ||
    context.mozBackingStorePixelRatio ||
    context.msBackingStorePixelRatio ||
    context.oBackingStorePixelRatio ||
    context.backingStorePixelRatio ||
    1

  return (window.devicePixelRatio || 1) / backingStore
}

// canvas图片合成
export const imgTogether = function (bg, img, offset, callback) {
  var canvas = document.createElement('canvas')

  var ratio = getPixelRatio(bg)

  canvas.width = bg.width * ratio
  canvas.height = bg.height * ratio

  var context = canvas.getContext('2d')

  // 绘制
  //  context.drawImage(img, 0, 0, size, size, 0,0, size, size);
  // 再次绘制
  //console.log(bg.width,bg.height,bg.naturalWidth,bg.naturalHeight)

  //console.log(bg.naturalWidth,bg.width,ratio)

  if (bg)
    context.drawImage(
      bg,
      0,
      0,
      bg.naturalWidth,
      bg.naturalHeight,
      0,
      0,
      canvas.width,
      canvas.height
    ) //, 0,0, bg.width*0.5, bg.height*0.5);

  if (img)
    context.drawImage(
      img,
      0,
      0,
      img.naturalWidth,
      img.naturalHeight,
      offset.left * ratio,
      offset.top * ratio,
      img.width * ratio,
      img.height * ratio
    )

  /*
            context.drawImage(bg, 0, 0, bg.naturalWidth, bg.naturalHeight, 0,0, bg.width, bg.height);
			context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight,offset.left, offset.top, img.width, img.height);
			*/
  // 回调
  //console.log(canvas.toDataURL('image/png'))

  callback(canvas.toDataURL('image/png', offset.q || 1))
}

export const isEmail = function (str) {
  var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
  return reg.test(str)
}

export const formatDate = function (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function sliceToChunks(target, chunkSize) {
  const result = []
  for (let i = 0; i < target.length; i += chunkSize) {
    const chunk = target.slice(i, i + chunkSize)
    result.push(chunk)
  }
  return result
}
